import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { act } from "@/lib/hooks";
import { api } from "@/lib/api";
import { Field, NativeSelect } from "@/components/common";

export function SizeDialog({ item, onClose, onDone }) {
  const roll = ["roll", "linear_m"].includes(item.uom);
  const [f, setF] = useState({ width: item.width ?? "", length: item.length ?? "", dim_unit: item.dim_unit || (roll ? "mm" : "mm") });
  const needLen = item.uom !== "linear_m";
  const ok = Number(f.width) > 0 && (!needLen || Number(f.length) > 0);
  const save = async () => {
    const body = { width: Number(f.width), length: f.length === "" ? null : Number(f.length), dim_unit: f.dim_unit };
    if (await act(() => api.put(`/inventory/items/${item.id}/size`, body), "Size saved — also updated in Estimating")) { onClose(); onDone(); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="size-dialog">
        <DialogHeader><DialogTitle>Set size · {item.name}</DialogTitle><DialogDescription>{roll ? "Roll width and length" : "Sheet width and height"} drive the sheet/roll suggestions and shortfall checks.</DialogDescription></DialogHeader>
        <div className="grid grid-cols-3 gap-3">
          <Field label={roll ? "Roll width" : "Width"}><Input type="number" min="0" data-testid="size-width-input" value={f.width} onChange={(e) => setF({ ...f, width: e.target.value })} /></Field>
          <Field label={roll ? `Roll length${needLen ? "" : " (optional)"}` : "Height"}><Input type="number" min="0" data-testid="size-length-input" value={f.length} onChange={(e) => setF({ ...f, length: e.target.value })} /></Field>
          <Field label="Unit"><NativeSelect testId="size-unit-select" value={f.dim_unit} onChange={(v) => setF({ ...f, dim_unit: v })} options={["mm", "cm", "in", "ft", "m"].map((x) => ({ value: x, label: x }))} /></Field>
        </div>
        {roll && <p className="text-xs text-slate-500">Tip: for a 1370mm x 50m roll, enter 1.37 and 50 in metres.</p>}
        <DialogFooter><Button data-testid="size-save-button" disabled={!ok} onClick={save}>Save size</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
